/** User-facing labels — backend/API still uses "workers" */
export const STAFF = {
  singular: 'Staff member',
  plural: 'Staff',
  management: 'Staff Management',
  add: 'Add Staff',
};
